module.exports = __webpack_public_path__ + "img/bg.357c9085.png";